import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

import OrderTrackingModal from "../my-orders/components/OrderTrackingModal";

import { use } from "react";
import { Link } from "react-router-dom";

import {
  addToCart,
  isInCart,
  updateCartItemQuantity,
  getCartQuantity,
  getCart,
  getUser,
} from "../../utils/cart";
import { useEffect, useDebugValue } from "react";

import {
  BaseUrl,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
  Authorization_Token,Unichat_Url
} from "../../Services/Urls";
import { TailSpin } from "react-loader-spinner";
import { makeApiRequest, callApi } from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

export default function OrderDetailPage() {
  const navigate = useNavigate();
  const context = useContext(ApiContext);

  if (!context) {
    throw new Error("useApiContext must be used within a ApiContextProvider");
  }

  const { logindata, setlogindata, userData, setuserData } = context;

  const { orderId } = useParams();

  const [showRatingModal, setShowRatingModal] = useState(false);
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState<any>(null);

  useEffect(() => {
    getOrderdetails();
    window.scrollTo(0, 0);
  }, []);

  const getOrderdetails = () => {
    const url = `${BaseUrl}/api/finance/viewBillingVouchers`;

    const body = {
      userID: 1002,
      vchID: orderId,
      tabErpID: 3017,
      collectionDate: "2025-04-01T00:00:00",
    };

    callApi(
      url,
      body,
      Authorization_Token,
      (response: any) => {
        if (
          response?.hasErrors == false &&
          response?.response?.records != null
        ) {
          setLoading(false);
          setOrder(response?.response?.records || null);
        } else {
          setLoading(false);
          setOrder(null);
        }
      },

      (error: any) => {
        setLoading(false);
        console.log(error);
      },
      (error: any) => {},
    );
  };

const getTrackdetails = async (): Promise<string> => {
  return new Promise((resolve, reject) => {
    const url = `${Unichat_Url}/shipway/track-order`;

    const body = {
      awb_numbers: order?.AwbNo,
    };

    callApi(url, body, "", (response: any) => {
      if (response && response.success === true) {
        const trackUrl =
          response?.data?.[0]?.tracking_details?.track_url ?? "";

        resolve(trackUrl);
      } else {
        resolve(""); // or reject("Failed")
      }
    });
  });
};

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Delivered":
        return "bg-green-100 text-green-700";
      case "Shipped":
        return "bg-blue-100 text-blue-700";
      case "Processing":
        return "bg-amber-100 text-amber-700";
      case "Cancelled":
        return "bg-red-100 text-red-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  if (!order) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <h1 className="text-2xl font-bold text-gray-900">Order not found</h1>
          <button
            onClick={() => navigate("/my-orders")}
            className="mt-6 px-6 py-3 bg-gray-900 text-white rounded-lg font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap"
          >
            Back to Orders
          </button>
        </div>
        <Footer />
      </div>
    );
  }

  const handleRepeatOrder = () => {
    // Add items to cart logic here
    alert("Items added to cart! View cart on next step.");
  };

const handleDownloadInvoice = (url: string) => {
  if (!url) {
    alert("No PDF found");
    return;
  }

  window.open(url, "_blank");
};
  const handleCopyOrderId = () => {
    navigator.clipboard.writeText(order.id);
    alert("Order ID copied to clipboard");
  };

const handleTrackOrder = async () => {
  try {
    const shipUrl: string = await getTrackdetails();

    if (!shipUrl) {
      alert("Tracking URL not available");
      return;
    }

    window.open(shipUrl, "_blank");

  } catch (err) {
    alert("Tracking URL not available");
  }
};

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="pt-24 pb-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          {/* Header */}
          <div className="bg-white rounded-t-2xl shadow-sm">
            <div className="px-4 py-4 flex items-center border-b border-gray-200">
              <button
                onClick={() => navigate("/my-orders")}
                className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
              >
                <i className="ri-arrow-left-line text-2xl text-gray-900"></i>
              </button>
              <h1 className="text-2xl font-bold text-gray-900 mb-0">
                Order summary
              </h1>
              {/* <button
                onClick={() => navigate('/cart')}
                className="w-10 h-10 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
              >
                <i className="ri-delete-bin-line text-2xl text-gray-900"></i>
              </button> */}
            </div>

            {/* Order Summary Header */}
            <div className="px-6 py-3">
              {/* <h1 className="text-2xl font-bold text-gray-900 mb-2">Order summary</h1> */}
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <p className="text-xs text-gray-500 mb-0">Order id</p>
                  <div className="flex items-center gap-2">
                    <p
                      className="text-sm font-medium text-gray-900"
                      style={{ marginLeft: 5 }}
                    >
                      {order.VchNo}
                    </p>
                    <button
                      onClick={handleCopyOrderId}
                      className="w-6 h-6 flex items-center justify-center hover:bg-gray-100 rounded transition-colors"
                    >
                      <i className="ri-file-copy-line text-gray-600"></i>
                    </button>
                  </div>
                </div>
                <span
                  className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(order.Status)}`}
                  style={{ marginLeft: 10 }}
                >
                  {order.Status}
                </span>
              </div>

              <div className="flex items-center gap-4">
                {/* <button
                  onClick={handleDownloadInvoice}
                  className="flex items-center gap-2 text-green-600 font-semibold text-sm hover:text-green-700 transition-colors"
                >
                  Download Invoice
                  <i className="ri-download-line"></i>
                </button> */}
                <button
                  onClick={() => handleTrackOrder()}
                  className="flex items-center gap-2 text-amber-600 font-semibold text-sm hover:text-amber-700 transition-colors"
                >
                  Track Order
                  <i className="ri-map-pin-time-line"></i>
                </button>
              </div>
            </div>

            {/* Items Section */}
            <div className="px-6 py-6 border-t border-gray-100">
              <h2 className="text-lg font-bold text-gray-900 mb-4">
                {order?.ObjItems.length} item
                {order?.ObjItems.length > 1 ? "s" : ""} in this order
              </h2>
              <div className="space-y-4">
                {order?.ObjItems?.map((item: any, index) => (
                  <div key={index} className="flex items-center gap-4">
                    <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                      <img
                        src={
                          "https://dialerpstorageac.blob.core.windows.net/10417/36/2596/2.png"
                        }
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">
                        {item.Item}
                      </h3>
                      <p className="text-xs text-gray-600">
                        {item.MSP} x {item.Qty}
                      </p>
                    </div>
                    <div className="text-right">
                      {/* <p className="text-sm text-gray-400 line-through">
                        ₹{Math.round(item.MSP * 1.24)}
                      </p> */}
                      <p className="text-base font-bold text-gray-900">
                        ₹{item.MSP * item.Qty}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Rating Section */}
            <div className="px-6 py-5 bg-gray-50 border-t border-gray-100">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-star-fill text-2xl text-yellow-400"></i>
                  </div>
                  <span className="text-sm font-medium text-gray-900">
                    How were your ordered items?
                  </span>
                </div>
                <button
                  onClick={() => setShowRatingModal(true)}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold text-sm hover:bg-green-700 transition-colors whitespace-nowrap"
                >
                  Rate now
                </button>
              </div>
            </div>

            {/* Bill Details */}
            <div className="px-6 py-6 border-t border-gray-100">
              <h2 className="text-lg font-bold text-gray-900 mb-4">
                Bill details
              </h2>
              <div className="space-y-3">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">MRP</span>
                  <span className="text-gray-900 font-medium">
                    ₹{Math.round(order?.TotalBillAmt)}
                  </span>
                </div>
                {/* <div className="flex justify-between text-sm">
                  <span className="text-blue-600">Product discount</span>
                  <span className="text-blue-600 font-medium">
                    -₹{Math.round(order?.TotalBillAmt)}
                  </span>
                </div> */}
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Item total</span>
                  <span className="text-gray-900 font-medium">
                    ₹{order?.TotalBillAmt}
                  </span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Handling charge</span>
                  <span className="text-gray-900 font-medium">₹0</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Delivery charges</span>
                  <span className="text-green-600 font-medium">FREE</span>
                </div>
                <div className="pt-3 border-t border-gray-200 flex justify-between">
                  <span className="text-base font-bold text-gray-900">
                    Bill total
                  </span>
                  <span className="text-base font-bold text-gray-900">
                    ₹{order.TotalBillAmt}
                  </span>
                </div>
              </div>
            </div>

            {/* Order Details */}
            <div className="px-6 py-6 border-t border-gray-100">
              <h2 className="text-lg font-bold text-gray-900 mb-4">
                Order details
              </h2>
              <div className="space-y-4">
                <div>
                  <p className="text-xs text-gray-500 mb-1">Payment</p>
                  <p className="text-sm font-medium text-gray-900">Paid</p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Order Date</p>
                  <p className="text-sm font-medium text-gray-900">
                    {new Date(order?.["VchDate"]).toLocaleDateString("en-IN", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </p>
                </div>

                <div>
                  <p className="text-xs text-gray-500 mb-1">Delivery Date</p>
                  <p className="text-sm font-medium text-gray-900">
                    {new Date(order.StrDeliveryDt).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}{" "}
                    
                  </p>
                </div>

                {/* <p className="text-sm text-gray-600 mb-3">
                Arrived at {new Date(order.deliveredDate || order.date).toLocaleTimeString('en-IN', { 
                  hour: '2-digit', 
                  minute: '2-digit',
                  hour12: true 
                })}
              </p> */}
                <div>
                  <p className="text-xs text-gray-500 mb-1">Delivery address</p>
                  <p className="text-sm font-medium text-gray-900">
                    {order?.ObjShipTo?.AddressLine1}, {order?.ObjShipTo?.City}, {order?.ObjShipTo?.State}, {order?.ObjShipTo?.Country}, {order?.ObjShipTo?.Pincode}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Repeat Order Button */}
          <div className="bg-white flex justify-center rounded-b-2xl shadow-sm px-6 py-4 border-t border-gray-100">
            <button
              onClick={() =>handleDownloadInvoice(order?.ShippingUrl)}
              className="w-half py-4 px-8 mx-2 bg-green-600 text-white rounded-lg font-bold text-base hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              Download Invoice{" "}
            </button>
            {/* <button
              onClick={handleRepeatOrder}
              className="w-half py-4 px-8 mx-2 bg-green-600 text-white rounded-lg font-bold text-base hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              Repeat Order
            </button> */}
          </div>
          <p className="text-center text-xs text-gray-500 mt-2">
            VIEW CART ON NEXT STEP
          </p>
        </div>
      </div>

      <Footer />

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}

      {/* Rating Modal */}
      {showRatingModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-xl font-bold text-gray-900">
                Rate Your Order
              </h3>
              <button
                onClick={() => setShowRatingModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-lg transition-colors"
              >
                <i className="ri-close-line text-2xl text-gray-600"></i>
              </button>
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-600 mb-4">
                How would you rate your experience?
              </p>
              <div className="flex justify-center gap-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    onClick={() => setRating(star)}
                    className="w-12 h-12 flex items-center justify-center transition-transform hover:scale-110"
                  >
                    <i
                      className={`text-4xl ${star <= rating ? "ri-star-fill text-yellow-400" : "ri-star-line text-gray-300"}`}
                    ></i>
                  </button>
                ))}
              </div>
            </div>

            <textarea
              placeholder="Share your feedback (optional)"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-green-500 mb-4"
              rows={4}
            ></textarea>

            <button
              onClick={() => {
                alert(`Thank you for rating ${rating} stars!`);
                setShowRatingModal(false);
              }}
              className="w-full py-3 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap"
            >
              Submit Rating
            </button>
          </div>
        </div>
      )}

      {/* Order Tracking Modal */}
      <OrderTrackingModal
        isOpen={showTrackingModal}
        onClose={() => setShowTrackingModal(false)}
        order={order}
      />
    </div>
  );
}
